import React from 'react'

const Newsletter = () => {
  return (
    <>
      <div className='mainNewsletter'>
        <div className='newsletterText'>
            <h2>Join Our Newsletter</h2>
            <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
            <div className='newsletterInput'>
                <input type="text" name="" id="" />
                <button>Subscribe</button>
            </div>  
        </div>
      </div>
    </>
  )
}

export default Newsletter
